import * as React from 'react';
import { Container, Row, Spacer, Text } from '@nextui-org/react';
import { useSession } from 'next-auth/react';
import Image from 'next/image';

import { routes } from '@src/config/constants';
import { useGetSignedInUserQuery } from '@src/generated/hooks';
import { AppFullWidthLoader } from '@src/layouts/app/AppFullWidthLoader';
import { AppTitle } from '@src/layouts/app/AppTitle';
import { AppUnauthorized } from '@src/layouts/app/AppUnauthorized';
import { AppWebShare } from '@src/layouts/app/AppWebShare';
import { buildUrl } from '@src/util/navigation';

interface InviteFriendProps {}

/**
 * @name InviteFriend
 * @description tbd...
 */
export function InviteFriend(_props: InviteFriendProps) {
  // const {} = props

  const { data: session, status } = useSession();

  // GraphQL
  const {
    data: userData,
    error: errorUserData,
    loading: loadingUserData,
  } = useGetSignedInUserQuery();

  // Setup
  const email = session?.user?.email;
  const path = `${routes.inviteAccepted}/${userData?.getSignedInUser?.id}`;
  const url = buildUrl(path);
  const loading = status === 'loading' || loadingUserData;

  if (status === 'unauthenticated' || errorUserData) {
    return <AppUnauthorized />;
  }

  return (
    <Container xs direction="row" gap={0}>
      <Spacer />
      <Row>
        <AppTitle color="green">
          <Image
            src="/icons/thumb-up-dynamic-color.png"
            width={40}
            height={40}
            priority={true}
          />
          Invite
        </AppTitle>
      </Row>
      <Spacer />
      <Row>
        <Text>
          Invite your friends to join you in playing games online. You can share
          your unique invite link below. When your friends join, you can start
          playing games together.
        </Text>
      </Row>
      <Spacer />
      <Row>
        {loading ? (
          <AppFullWidthLoader />
        ) : (
          <AppWebShare
            url={url}
            text={`Add ${email} to your friends list!`}
            title={`Join me to play games online!`}
          />
        )}
      </Row>
    </Container>
  );
}
